<ng-container *ngIf="action$ | async as action">
    <ng-container *ngIf="config$ | async as actionConfig">
        <ng-container appNoopViewProvider [typeName]="actionConfig.relatedTypeName">
            <ntap-view-window #childWindow target="detail" [contentTemplate]="viewWindowContent">
                <ng-template #viewWindowContent let-defaultTemplate>
                    <ng-container ntapDynamicFormProvider>
                        <ntap-prime-popupview appendTo="body" [modal]="true">
                            <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
                        </ntap-prime-popupview>
                    </ng-container>
                </ng-template>
            </ntap-view-window>
        </ng-container>
        <ng-container ntapNewListItemProvider>
            <p-button icon="pi pi-user-plus" [label]="action.description" ntapDebounceClick (onClick)="executeAction($event)"
                [disabled]="(isDisabled$ | async) ?? true"></p-button>
        </ng-container>
    </ng-container>
</ng-container>